import { useSelector } from '@xstate/react';
import { useLayoutEffect } from 'react';
import type { ActorRefFrom } from 'xstate';
import { LoadingSpinner } from '~/components';
import { EmployerFacilityValuesForm } from './forms/EmployerFacilityForm';
import { RegistrationCompletePage, WelcomePage } from './pages';
import { PendingVerification } from './pages/PendingVerification';
import { employerRegistrationView } from './registration-view.machine';
import { RegistrationEmployerInfoForm } from './RegistrationEmployerInfoForm';

interface RegistrationProps {
  actorRef: ActorRefFrom<typeof employerRegistrationView>;
}

export function Registration({ actorRef }: RegistrationProps) {
  const currentState = useSelector(actorRef, (snapshot) => {
    if (snapshot.matches('$_WELCOME')) return '/registration/employer/welcome';
    if (snapshot.matches('$_EMPLOYER_INFO')) return '/registration/employer/info';
    if (snapshot.matches('$_EMPLOYER_FACILITY')) return '/registration/employer/facility';
    if (snapshot.matches('$_PENDING_VERIFICATION')) return '/registration/employer/pending';
    if (snapshot.matches('$_COMPLETING')) return '/registration/employer/complete';
    return '/registration/loading';
  });

  useLayoutEffect(() => {
    // Signup steps share a route and scroll the document. Start each new
    // step at its heading without disturbing edits within the current step.
    window.scrollTo(0, 0);
  }, [currentState]);

  const renderPage = () => {
    switch (currentState) {
      case '/registration/employer/welcome':
        return <WelcomePage actorRef={actorRef} />;
      case '/registration/employer/info':
        return <RegistrationEmployerInfoForm actorRef={actorRef} />;
      case '/registration/employer/facility':
        return <EmployerFacilityValuesForm actorRef={actorRef} />;
      case '/registration/employer/pending':
        return <PendingVerification actorRef={actorRef} />;
      case '/registration/employer/complete':
        return <RegistrationCompletePage actorRef={actorRef} />;
      default:
        return <LoadingSpinner size={30} gap={0} speed={300} />;
    }
  };
  return (
    <div className="registration-container">
      <div className="flex flex-col items-center justify-center min-h-screen px-4 py-8 bg-primary-t-950">
        <div className="flex flex-col w-full max-w-[475px]">
          <div className="w-full">{renderPage()}</div>
        </div>
      </div>
    </div>
  );
}
